<template>
    <v-card flat>
        <v-card-title class="subheader py-0">
            <v-icon small class="mr-1" color="teal">group</v-icon>
            项目到款认领
            <v-spacer/>
            <v-btn flat round color="primary" dark
                   :disabled="!funcIds.includes('a_proj_inco_claim')|| incoClaim.statusId === 'checked'"
                   @click.native.stop="
             () => {
                  addDbid = incoClaim? incoClaim.pznm: null;
                  addFlbh = incoClaim? incoClaim.flbh: null;
                  add = true;
                }">
                <v-icon>add</v-icon>
                新增项目
            </v-btn>
        </v-card-title>

        <v-divider color="teal"/>

        <v-card-text class="pt-0">
            <v-data-table
                    :headers="headers"
                    :items="items"
                    hide-actions
                    class="elevation-0 dense"
                    no-data-text="没有数据。"
            >
                <template slot="items" slot-scope="props">
                    <td>{{props.index + 1}}</td>
                    <td class="">{{props.item.projName}}</td>
                    <td class="">{{props.item.projNumber}}</td>
                    <td class="min-width:4em">{{props.item.deptName}}</td>
                    <td class="">{{props.item.leaderName}}</td>
                    <td v-if="props.item.statusId === 'await'">
                        <v-text-field
                                :rules="rules.money"
                                v-model="items[props.index].money"
                                @change="updateMoney(props.index)"
                        />
                    </td>
                    <td v-else>
                        {{props.item.money}}
                    </td>
                    <td class="justify-center layout px-0">
                        <v-tooltip top>
                            <v-btn icon class="mx-0" slot="activator"
                                   :disabled="!funcIds.includes('d_proj_inco_claim')"
                                   @click="
                     () => {
                        deleDbid = props.item.dbid;
                        deleMsg = `${props.item.projName} / ${props.item.leaderName || ''}`;
                        dele = true;
                     }">
                                <v-icon color="pink">delete_forever</v-icon>
                            </v-btn>
                            <span>删除</span>
                        </v-tooltip>
                    </td>
                </template>
                <template v-slot:footer>
                    <td>
                        <strong>合计：</strong>
                    </td>
                    <td :colspan="2" align="center">
                        <strong>{{totalMoney}}</strong>
                    </td>
                    <td>
                        <strong>差额：</strong>
                    </td>
                    <td :colspan="3" align="center">
                        <strong>{{allMoney - totalMoney}}</strong>
                    </td>
                </template>
            </v-data-table>
        </v-card-text>
        <v-divider/>
        <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
            <v-layout row wrap>
                <v-flex xs12 sm4>
                    <v-autocomplete
                            item-text="name"
                            item-value="dbid"
                            :items="partItems"
                            v-model="form.partId"
                            label="拆分模板"
                            hide-details
                            clearable
                            :menu-props="{maxHeight:450}"/>
                </v-flex>
                <v-flex d-flex xs2 text-xs-center>
                    <div>
                        <v-btn color="primary" slot="activator"
                               :disabled="!funcIds.includes('d_proj_inco_claim')"
                               @click="onConfirmSubmit( submitDbid = incoClaim? incoClaim.pznm: null,submitFlbh = incoClaim? incoClaim.flbh: null)">
                            确认认款
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>

        <v-dialog
                scrollable
                v-model="submit"
                max-width="600px"
                :persistent="true"
        >
            <v-card>
                <v-card-title class="subheading">
                    {{ loading ? '正在提交…': '确认提交？' }}
                </v-card-title>

                <v-divider></v-divider>

                <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

                <v-card-text>
                    <p class="subheading">{{ `请问确认要提交这笔认款吗？到款：${allMoney}元；实际认款 ${totalMoney}元` }}</p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn flat color="primary" @click.native="submit = false">取消</v-btn>
                    <v-btn color="primary" :disabled="loading" @click.native="onSubmit">确认</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <x-add
                v-model="add"
                :dbid="addDbid"
                :flbh="addFlbh"
                v-on:ok="onAddOk"
        />

        <x-delete
                v-model="dele"
                :message="deleMsg"
                :uri="uri"
                :dbid="deleDbid"
                v-on:ok="onDeleOk"
        />

    </v-card>
</template>
<script>
    import {mapGetters} from 'vuex'
    import XAdd from './add'

    import XDelete from '@/components/global/Delete'

    const baseURI = '/api/proj/incoclaim';
    const partitionUri = '/api/proj/fund/partition';
    const submitURI = '/api/proj/incoclaim';
    export default {
        components: {XAdd, XDelete},

        props: {
            incoClaim: Object
        },

        data: () => ({
            uri: baseURI,
            headers: [
                {
                    text: '#',
                    sortable: false,
                    value: 'dbid',
                    width: '20'
                },
                {text: '项目名称', value: 'projName', sortable: false, width: 200},
                {text: '项目编号', value: 'projNumber', sortable: false, width: 20},
                {text: '项目所属部门', value: 'deptName', sortable: false, width: 120},
                {text: '项目负责人', value: 'leaderName', sortable: false, width: 40},
                {text: '金额(元)', value: 'money', sortable: false, width: 60},
                {text: '操作', value: 'dbid', sortable: false, align: 'center', width: 120}
            ],
            form: {
                partId: '',
            },
            items: [],
            partItems: [],
            allMoney: null,

            add: false,
            addDbid: null,
            claimPznmAdd: null,

            submit: false,
            submitDbid: null,
            submitFlbh: null,
            submitLoading: false,
            loading: false,

            dele: false,
            deleDbid: null,
            deleMsg: null,

            /**
             * 验证规则
             */
            rules: {
                money: [
                    v => !!v || '必填项。',
                    v => (v && /^\d{1,10}?(\.[0-9][0-9]?)?$/ig.test(v)) || '填写数字，小数点后最多保留2位。'
                ],
            }
        }),

        beforeMount() {
            this.axios.all([
                this.axios.get(partitionUri)
            ]).then(
                this.axios.spread(
                    (rspPar) => {
                        this.partItems = rspPar.data.items;
                    }
                )
            )
        },

        watch: {
            incoClaim(p) {
                const dbid = p.pznm;
                const flbh = p.flbh;
                this.allMoney = p.je;
                this.axios
                    .get(`${baseURI}/claim/${dbid}`+`?flbh=${flbh}`)
                    .then(rsp => {this.items = rsp.data.items})
            }
        },

        computed: {
            ...mapGetters(['funcIds']),
            totalMoney() {
                if (!this.items)
                    return 0.0;
                window.console.log()
                return this.items.map(it => it.money).reduce((a, b) => Number(a) + Number(b), 0)
            }
        },
        methods: {
            getDefault() {
                return {
                    claimPznm: this.incoClaim.pznm,
                    serialNum: this.items.length + 1,
                    property: !this.items.length ? '新立' : '追加',
                }
            },
            onAddOk(its) {
                window.console.log(its);
                if (its) {
                    this.items.unshift(...its);
                }
            },
            onEditOk(item) {
                if (item) {
                    if (!this.editDbid) {
                        this.items.unshift(item);
                    } else {
                        const editIdx = this.items.findIndex(v => v.dbid === item.dbid);
                        this.items[editIdx] = window.xutil.clone(item);
                    }
                }
            },
            onDeleOk(item) {
                if (item) {
                    const deleIdx = this.items.findIndex(v => v.dbid === item.dbid);
                    this.items.splice(deleIdx, 1);
                }
            },
            onConfirmSubmit(dbid,flbh) {
                this.submitDbid = dbid;
                this.submitFlbh = flbh;
                this.submit = true;
            },
            onSubmit() {
                const vm = this;
                vm.submitLoading = true;
                const dbid = this.submitDbid;
                const flbh = this.submitFlbh;
                const params = Object.assign(
                    window.xutil.param("partId", this.form.partId)
                );
                this.axios.put(`${submitURI}/submit/${dbid}`+`?flbh=${flbh}`, params)
                    .then(rsp => {
                        vm.submitLoading = false;
                        vm.items = rsp.data.items;
                        this.submit = false;
                    })
            },
            updateMoney(idx) {
                const vm = this;
                const money = Number(this.items[idx].money);
                const dbid = this.items[idx].dbid;
                this.axios.put(`${baseURI}/edit/${dbid}`, {money: money})
                    .then(rsp => {
                        vm.visible = false;
                        vm.$emit('ok', rsp.data);
                        vm.loading = false;
                    })
            },
        }
    }
</script>
